import {combineReducers} from 'redux';

import {VisibilitySliceFor} from '../../../store/VisibilitySliceFor';
import {SelectionSliceFor} from '../../../store/SelectionSliceFor';

const entityKey = 'domainNames';

const visibilitySlice = VisibilitySliceFor(entityKey);
const selectionSlice = SelectionSliceFor(entityKey);

export const {
    setPage,
    incrementPage,
    decrementPage,
    setPageSize,
    resetPageSize,
    setKeyword,
    clearKeyword,
    show,
    hide,
    toggleVisibility,
    setTableColumns,
    addTableColumn,
} = visibilitySlice.actions;

export const {
    addToSelection,
    removeFromSelection,
    clearSelection,
} =
    selectionSlice.actions;

// FNP-942: the `records` sub-reducer is gone — records live in React Query.
// Selection and visibility remain: selection is the platform standard (FNP-951)
// and visibility holds page/limit/keyword/columns.
export const DomainNamesReducer = combineReducers({
                                                      selection: selectionSlice.reducer,
                                                      visibility: visibilitySlice.reducer,
                                                  });

